var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVetShortist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25292 2.05016C7.55871 1.43119 8.44139 1.4312 8.74718 2.05016L10.3921 5.37974L14.0685 5.91199C14.7527 6.01105 15.0257 6.85219 14.53 7.33417L11.8661 9.92458L12.4942 13.5825C12.6111 14.2635 11.8961 14.7828 11.2847 14.4609L8.00446 12.7341L4.71458 14.4621C4.10316 14.7832 3.3889 14.2639 3.50578 13.5833L4.13404 9.92458L1.47009 7.33417C0.974429 6.85219 1.24741 6.01105 1.93164 5.91199L5.608 5.37974L7.25292 2.05016Z",
    fill: "#FDB058"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetShortist);
export default __webpack_public_path__ + "static/media/vet-shortist.4cf46fa2b840b62d0e1c7df3b051cd08.svg";
export { ForwardRef as ReactComponent };